// extracted by mini-css-extract-plugin
export default {"root":"ProjectChart_root__d6Nkq","inner":"ProjectChart_inner__WFG+g"};